import { GroupType, groupTypeMissingDataMessageFor } from '~/enums/groupType';
import PermitteeVOptionSetMixin from '~/mixins/permitteeVOptionSetMixin';

export default {
  mixins: [
    PermitteeVOptionSetMixin,
  ],
  created() {
    if (!this.selectedOrganization) console.error('Component missing required selectedOrganization data.');
    if (!this.updateAppGroupVOptionSets) console.error('Component missing required updateAppGroupVOptionSets() method.');

    $.ajax({
      url: `${this.appGroupSearchBaseRoute}/groups_search_needs_data`,
      data: { organization_id: this.selectedOrganization.id },
    }).then((res) => {
      this.setAppGroupEmptySearchStatus(res.search_needs_data);
    }).always(() => {
      this.updateAppGroupVOptionSets();
    })
  },
  computed: {
    appGroupSearchByOrg(): boolean {
      // override in mixed-in component if your document is not scoped to an Application
      return false;
    },
    appGroupSearchBaseRoute(): string {
      if (this.appGroupSearchByOrg) return this._orgScopedAppGroupSearchBaseRoute;

      return this._appScopedAppGroupSearchBaseRoute;
    },
    _appScopedAppGroupSearchBaseRoute(): string {
      if (!this.application_id) console.error('Component missing required application_id data.');

      return `/apps/${ this.application_id }`;
    },
    _orgScopedAppGroupSearchBaseRoute(): string {
      return `/organizations/${ this.selectedOrganization.id }`;
    },
  },
  methods: {
    setAppGroupEmptySearchStatus(search_needs_data: { [key in GroupType]: boolean }): void {
      // these VOptionSets are computed props (i.e. cached, return the same object), so we can mutate them once to update all VOptionSets that use them,
      //  but we must pass those VOptionSets to their a-selects *after* this mutation is done.
      if (search_needs_data[GroupType.Application]) {
        this.appGroupsVOptionSet.emptySearchStatus = groupTypeMissingDataMessageFor(GroupType.Application);
      }
      if (search_needs_data[GroupType.Organization]) {
        const msg = groupTypeMissingDataMessageFor(GroupType.Organization, this.appGroupSearchByOrg);
        this.appAssignedOrgGroupsVOptionSet.emptySearchStatus = msg
        this.orgGroupsVOptionSet.emptySearchStatus = msg
      }
    },
  },
};